export default ({ request }) => ({
  materialInfoListApi(data = {}) {
    return request({
      url: '/master/material/info/list',
      method: 'post',
      data,
    })
  },

})
